import React from 'react'

export default function CasinoIcon(props: any) {
  return (
    <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.333984 15.2733C0.333984 16.8515 2.07629 17.8079 3.40774 16.9606L13.2658 10.6873C14.5008 9.90142 14.5008 8.09859 13.2658 7.31268L3.40774 1.03936C2.07629 0.192074 0.333984 1.1485 0.333984 2.72668V15.2733Z" fill="white"/>
    </svg>
  )
}